import { render, staticRenderFns } from "./NewsletterForm.vue?vue&type=template&id=21b1d838&scoped=true&"
import script from "./NewsletterForm.vue?vue&type=script&lang=ts&"
export * from "./NewsletterForm.vue?vue&type=script&lang=ts&"
import style0 from "./NewsletterForm.vue?vue&type=style&index=0&id=21b1d838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b1d838",
  null
  
)

export default component.exports